import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Unregistered, tailwind-merge classifies the named text styles as text
// colors and drops them against any `text-{color}` class. It also cannot
// resolve `blurred-backdrop-*` against `bg-*`; both set background-color.
const twMerge = extendTailwindMerge<'blurred-backdrop'>({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'large-title',
            'title',
            'headline',
            'body',
            'subheadline-emphasized',
            'subheadline',
            'footnote',
          ],
        },
      ],
      'blurred-backdrop': [{ 'blurred-backdrop': [() => true] }],
    },
    conflictingClassGroups: {
      'blurred-backdrop': ['bg-color'],
      'bg-color': ['blurred-backdrop'],
    },
  },
});

/**
 * Compose Tailwind class names with conflict resolution.
 *
 * Use this in every new component instead of bare `clsx`. When a component
 * accepts a `className` override prop, `cn` ensures the consumer's class
 * wins over the component-internal class targeting the same property.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
